import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StatusService } from '../services/status/status.service';

@Injectable()
export class StateableGuard {
  constructor(private readonly statusService: StatusService) {}

  canActivate(_next: ActivatedRouteSnapshot): boolean {
    return true;
  }
}
